import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  description?: string;
  footer?: React.ReactNode;
  maxWidth?: string;
  showLogo?: boolean;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  description,
  footer,
  maxWidth = 'max-w-md',
  showLogo = true,
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-coaching-background to-white p-4">
      <Card className={`w-full ${maxWidth} border-coaching-light/20 shadow-md`}>
        <CardHeader className="space-y-1">
          {showLogo && (
            <div className="flex justify-center mb-4">
              <img 
                src="/lovable-uploads/ddc85206-c911-40ff-878f-a9ba074283b9.png" 
                alt="Coach Vault Logo" 
                className="h-20 w-20 object-contain"
              />
            </div>
          )}
          <CardTitle className="text-2xl font-semibold text-center">{title}</CardTitle>
          {description && (
            <CardDescription className="text-center">{description}</CardDescription>
          )}
        </CardHeader>
        <CardContent>{children}</CardContent>
        {footer && <CardFooter className="flex justify-center">{footer}</CardFooter>}
      </Card>
    </div>
  );
};

export default AuthLayout; 